// extracted by mini-css-extract-plugin
export default {"code-wrapper":"CodeDown_code-wrapper__DsiH7"};